/**
 * Moonou Collection Hero — Marquee Element
 *
 * Custom marquee with separate desktop/mobile speed settings.
 * Clones content for seamless looping, pauses when out of viewport.
 */

class MchMarquee extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.resizeTimeout = null;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!this.initialized) this.init();
          this.classList.remove('paused');
        } else {
          this.classList.add('paused');
        }
      });
    }, { rootMargin: '200px 0px 200px 0px' });

    observer.observe(this);
  }

  get track() {
    return this.firstElementChild;
  }

  get direction() {
    return this.getAttribute('data-direction') || 'left';
  }

  init() {
    if (this.initialized || !this.track) return;
    this.initialized = true;

    if (this.direction === 'right') {
      this.classList.add('mch-direction-right');
    }

    const parentWidth = this.offsetWidth;
    const trackWidth = this.track.scrollWidth;
    const clones = Math.ceil(parentWidth / trackWidth) + 2;

    for (let i = 0; i < clones; i++) {
      const clone = this.track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[href], button').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
      this.appendChild(clone);
    }

    this.querySelectorAll('.mch-marquee-track').forEach((track) => {
      track.classList.add('animated');
    });
    this.updateSpeed();

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.updateSpeed(), 150);
    });
  }

  updateSpeed() {
    if (!this.track) return;

    const isMobile = window.innerWidth < 768;
    const speed = isMobile
      ? parseInt(this.getAttribute('data-speed-mobile') || '16')
      : parseInt(this.getAttribute('data-speed-desktop') || '20');

    const trackWidth = this.track.scrollWidth;
    const parentWidth = this.offsetWidth;
    const duration = (33 - speed) * Math.min(2.5, Math.ceil(trackWidth / parentWidth));

    this.style.setProperty('--mch-duration', `${duration}s`);
  }
}

customElements.define('mch-marquee', MchMarquee);
